import axios from 'axios';
import authService from './authService';

const API_URL = '/blog/';

// Add a request interceptor to include the auth token
axios.interceptors.request.use(
  (config) => {
    const user = authService.getCurrentUser();
    if (user && user.accessToken) {
      config.headers.Authorization = 'Bearer ' + user.accessToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

class BlogService {
  // Public endpoints
  getPublishedPosts() {
    return axios.get(API_URL + 'public/posts');
  }

  getPublishedPost(id) {
    return axios.get(API_URL + `public/posts/${id}`);
  }

  // Admin endpoints
  getAllPosts(page = 0, size = 10, sortBy = 'createdAt', sortDir = 'desc') {
    return axios.get(API_URL + `admin/posts?page=${page}&size=${size}&sortBy=${sortBy}&sortDir=${sortDir}`);
  }

  getPost(id) {
    return axios.get(API_URL + `admin/posts/${id}`);
  }

  createPost(postData) {
    return axios.post(API_URL + 'admin/posts', postData);
  }

  updatePost(id, postData) {
    return axios.put(API_URL + `admin/posts/${id}`, postData);
  }

  deletePost(id) {
    return axios.delete(API_URL + `admin/posts/${id}`);
  }
}

export default new BlogService();